module.exports = __webpack_public_path__ + "static/media/import.db1cc31b.svg";